// Booking5 pending-hold storage.
// After a successful submitBooking, we hold the booking_code + payment_url
// in sessionStorage so a user who navigates away can resume payment without
// booking again against their own inventory hold.

const KEY = "sg_pending_booking_v1";

export interface PendingBooking {
  booking_code: string;
  payment_url?: string;
  deadline_epoch_ms: number;
  total: number;
  saved_at: number;
}

function safeStorage(): Storage | null {
  try { return typeof window !== "undefined" ? window.sessionStorage : null; }
  catch { return null; }
}

export function savePendingBooking(p: PendingBooking): void {
  const s = safeStorage();
  if (!s) return;
  try { s.setItem(KEY, JSON.stringify(p)); } catch { /* ignore */ }
}

export function readPendingBooking(): PendingBooking | null {
  const s = safeStorage();
  if (!s) return null;
  try {
    const raw = s.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as PendingBooking;
    if (!parsed?.booking_code || !parsed?.deadline_epoch_ms) return null;
    if (Date.now() >= parsed.deadline_epoch_ms) {
      s.removeItem(KEY);
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function clearPendingBooking(): void {
  const s = safeStorage();
  if (!s) return;
  try { s.removeItem(KEY); } catch { /* ignore */ }
}
